module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAKCAYAAAApWHduAAAABHNCSVQICAgIfAhkiAAAAL9JREFUOE9jZMABnj9/Hv////8GoPQDKSkpR1zq6CHOiG4J0HEO//7962dkZDSAyQEdiaGOHo6D2QG3HOg4BWDIzQdKOKA7YMAdCXIcMOTqgSGXgCd0DtAz5NDtYnz69Ol7oAMFBtIRhOxmfPbs2QKgonhCCgdSHpwmQZkFmpPtsTkGGNKDJ3cDQzUA6MgJQCyP7NgBzzjYQg7o2AKgOKiM5Afij0BHDmiaxVn+vX//XuD79++gHA8qzDcMZJoEAEHEPNOPpScHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/friend_left.png
// module id = 1J9m
// module chunks = 12